import { render } from "./ProspectAssignment.vue?vue&type=template&id=15792e32"
import script from "./ProspectAssignment.vue?vue&type=script&lang=js"
export * from "./ProspectAssignment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__